import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface FaqItem {
  question: string;
  answer: string;
  open: boolean;
}

@Component({
  selector: 'app-pricing-faq',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pricing-faq.html',
  styleUrls: ['./pricing-faq.css'],
})
export class PricingFaqComponent {
  faqs: FaqItem[] = [
    {
      question: 'How does orderYaa ERP work?',
      answer: 'orderYaa ERP is a cloud-based platform that connects all your business operations — HR, Sales, Inventory, Accounting, CRM, and more — in one place. Simply sign up, select the modules you need, and start managing your business from a single dashboard accessible anywhere.',
      open: true,
    },
    {
      question: 'Is orderYaa ERP secure?',
      answer: 'Yes. orderYaa ERP uses industry-standard encryption (TLS/SSL) for all data in transit and AES-256 for data at rest. We perform regular security audits, role-based access controls, and automated backups to keep your business data safe at all times.',
      open: false,
    },
    {
      question: 'What kind of payments does orderYaa ERP support?',
      answer: 'orderYaa ERP supports a wide range of payment methods including credit/debit cards, bank transfers, and popular digital wallets. All transactions are processed through secure, PCI-DSS-compliant payment gateways.',
      open: false,
    },
    {
      question: "What's included in my subscription?",
      answer: 'Your subscription includes access to all modules in your selected plan, unlimited users, automatic updates, cloud hosting, customer support, and regular backups. The Custom plan additionally includes multi-company support and External API access.',
      open: false,
    },
    {
      question: 'How do you define a paying user?',
      answer: 'A paying user is any individual who logs into and actively uses the orderYaa ERP system within your organisation. Administrators, managers, and staff members who access the platform all count as users under your subscription.',
      open: false,
    },
    {
      question: 'Can I upgrade or downgrade my plan?',
      answer: 'Absolutely. You can upgrade or downgrade your plan at any time from your account settings. Changes take effect immediately, and any billing adjustments are prorated for the remainder of your billing cycle.',
      open: false,
    },
    {
      question: 'Is there a free trial available?',
      answer: 'Yes, orderYaa ERP offers a free trial so you can explore all features before committing to a plan. No credit card is required to start your trial, and you can upgrade to a paid plan at any time during or after the trial period.',
      open: false,
    },
  ];

  toggle(index: number): void {
    this.faqs[index].open = !this.faqs[index].open;
  }
}
